package com.essntl.features.invoice.ui.addeditinvoice.components.content

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceEvent
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceNavigation
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.allinvoice.components.InvoicingActionButtons
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.file.FileViewer
import com.essntl.uikit.components.utils.EsModifiers.LargeSectionModifier
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.launch
import org.koin.compose.koinInject

@Composable
fun AddEditInvoiceHeader(
    state: AddEditInvoiceState,
    onEvent: (AddEditInvoiceEvent) -> Unit,
    onNavigation: (AddEditInvoiceNavigation) -> Unit,
) {
    val invoiceId = state.getInvoice.data?.id
    val qbInvoice = state.getQuickbooksInvoice.data
    val scope = rememberCoroutineScope()
    val toastManager = koinInject<ToastManager>()

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = LargeSectionModifier,
    ) {
        Text(
            text = if (invoiceId.isNullOrEmpty())
                "New invoice" else
                "Invoice ${qbInvoice?.DocNumber}",
            style = MaterialTheme.esTypography.h1ExtraBold36,
            color = MaterialTheme.esColorScheme.textPrimary,
        )

        Spacer(modifier = Modifier.weight(1f))

        EsLargeSecondaryButton(
            onClick = {
                onNavigation(AddEditInvoiceNavigation.AddExtraService)
            },
            text = "Add extra service",
            enabled = !state.isLoading,
        )

        qbInvoice?.let {
            Spacer(modifier = Modifier.width(2.spacing))
            InvoicingActionButtons(
                qbInvoice = it,
                loadingDownloadQuickbookIds = state.loadingDownloadQuickbookIds,
                downloadQuickbooksInvoiceState = state.downloadQuickbooksInvoice,
                onDownloadInvoice = {
                    onEvent(AddEditInvoiceEvent.DownloadInvoice(it))
                },
            )
        }
    }

    if (!invoiceId.isNullOrEmpty())
        FileViewer(
            fileUrl = state.downloadQuickbooksInvoice.data?.first.orEmpty(),
            fileBaseName = state.downloadQuickbooksInvoice.data?.second?.DocNumber?.let {
                "invoice_$it"
            },
            extension = "pdf",
            isDialogOpened = state.downloadQuickbooksInvoice.isSuccess,
            onDismissRequest = {
                onEvent(AddEditInvoiceEvent.ClearDownloadInvoice)
            },
            onDownloadSuccess = {
                val invoiceDocNumber =
                    state.downloadQuickbooksInvoice.data?.second?.DocNumber?.let {
                        " $it"
                    }

                scope.launch {
                    toastManager.success(description = "Invoice$invoiceDocNumber downloaded!")
                }
            },
        )
}